import React, { Component } from 'react';
import { connect } from "react-redux";
import { Theme, i18n, tokens, Text } from '@simplybenefits/sb-ui-library';
import { setCurrentSidebarItem } from '../../actions/user.js';
import store from '../../redux/store.js';
import English from './English.js';
import French from './French.js';

const styles = {
    cards: {
        display: 'flex',
        maxWidth: '100%',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    logo: {
        height: 40
    },
    icon: {
        height: 30
    },
    cardInner: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'flex-start'
    },
    cardTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 40,
        paddingRight: 40,
        marginTop: 20
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: 40,
        paddingLeft: 40
    },
    cardContentRight: {
        width: '50%',
        paddingLeft: 35
    },
    cardContentFull: {
        width: '100%'
    },
    cardMobileDetails: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 20,
        marginRight: 20
    },
    cardMobileRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline'
    },
    cardDetailsLower: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignContent: 'center',
        paddingLeft: 40,
        paddingRight: 40
    },
    centerBlock: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
        whiteSpace: "nowrap"
    },
    wrapBlock: {
        display: 'flex',
        flexWrap: "nowrap",
        wordBreak: 'break-all',
        marginRight: 10
    },
    cardFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 10,
        backgroundColor: store.getState().whitelabel.primaryColor || Theme.colors.skyBlue,
        width: '100%'
    },
    downloadBtnContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
        marginBottom: 10
    },
    benefit: {
        width: "21%",
        marginRight: 10
    },
    carrier: {
        width: "42%"
    },
    policyNo: {
        width: "21%"
    },
    certNo: {
        width: "20%",
        display: "flex",
        justifyContent: "flex-end"
    },
    dataRow: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'space-between',
        alignItems: "center", 
        paddingTop: 10,
        paddingBottom: 10,
        borderBottom: `1pt solid #EEEEEE`
    }
};

/**
 * 
 * @param {*} props 
 * @returns 
 */
class Card extends Component {
    componentDidMount() {
        this.props.dispatch(setCurrentSidebarItem('benefits-card'));
    }

    _navigateTo = () => {
        window.open("http://simplybenefits.ca", "_blank");
    };

    _truncateString = (str, num) => {
        if (str.length <= num) {
            return str;
        }

        return `${ str.slice(0, num) }... `;
    };

    _getOocPolicyNumber = (user, carrier) => {
        if (user.oocPolicyNumber) {
            return user.oocPolicyNumber;
        }

        /**
         * If no OOC Policy Number stored then check for carrier defaults
         */
        if (carrier === "AIG") {
            return user.isStudentGroup ? "9429934" : "9429103";
        }

        if (carrier === "Desjardins") {
            return user.groupNum;
        }

        return null;
    };

    render() {
        const { user, coverage } = this.props;
        const carrier = coverage.outOfCountry.carrier || 'Orion';
        const whitelabel = store.getState().whitelabel;
        const name = this._truncateString(this.props.isDependent ? `${ user.parentFirstName } ${ user.parentLastName }` : `${ user.firstname } ${ user.lastname }`, 35);
        const company = this._truncateString(user.company, 40);
        const className = this._truncateString(user.className, 12);
        const divisionName = this._truncateString(user.divisionName, 12);
        const oocPolicyNo = this._getOocPolicyNumber(user, coverage.outOfCountry.carrier);

        return (
            <>
                <div style={ styles.cards }>
                        
                    {
                        i18n.locale === "fr" ?
                            <French 
                                whitelabel={whitelabel}
                                user={user}
                                className={className}
                                coverage={coverage}
                                company={company}
                                divisionName={divisionName}
                                oocPolicyNo={oocPolicyNo}
                                carrier={carrier}
                                name={name}
                                _navigateTo={this._navigateTo}
                            />
                            :
                            <English
                                whitelabel={whitelabel}
                                user={user}
                                className={className}
                                coverage={coverage}
                                company={company}
                                divisionName={divisionName}
                                oocPolicyNo={oocPolicyNo}
                                carrier={carrier}
                                name={name}
                                _navigateTo={this._navigateTo}
                            />
                    }
                </div>
                <Text small customStyle={{ textAlign: 'center', marginTop: 10 }}>{ i18n.t(tokens.labels.dashboard.benefitsCardNote) }</Text>
            </>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    user: state.user.meta,
    whitelabel: state.whitelabel,
    isDependent: state.user.meta.isDependent,
    coverage: state.coverage.data
});

export default connect(mapStateToProps)(Card);